var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5720_26302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 2.97665V9.02498L8.76457 7.25815H8.73242V4.74349H8.76457L12.0003 2.97665Z",
    fill: "#FF9DAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73213 7.25815V8.61296C8.73213 9.19942 8.25664 9.67491 7.67018 9.67491H1.06195C0.475491 9.67491 0 9.19942 0 8.61296V3.37167C0 2.78521 0.475491 2.30972 1.06195 2.30972H7.67018C8.25664 2.30972 8.73213 2.78521 8.73213 3.37167V7.25815Z",
    fill: "#FF284F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5720_26302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.73d81cc7f69d874832f29580cdb8453c.svg";
export { ForwardRef as ReactComponent };